import { baseFetch } from './fetch.ts'

export const fetchApi = async <T>(
  path: string,
  options: RequestInit = {},
  accessToken?: null | string,
) => {
  return await baseFetch<T>(
    process.env.NEXT_PUBLIC_API_URL + path,
    { ...options },
    accessToken,
    process.env.NEXT_PUBLIC_SOURCE,
  )
}
